import { FirebaseOptions } from "@firebase/app";

const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string;

const getFirebaseConfig = (): FirebaseOptions => {
  return {
    apiKey,
    authDomain: "sidejuice-dev.firebaseapp.com",
    projectId: "sidejuice-dev",
    storageBucket: "sidejuice-dev.firebasestorage.app",
    messagingSenderId: "522261853853",
    appId: "1:522261853853:web:93ed67fb06e153fcb54674",
  };
};

const firebaseConfig = getFirebaseConfig();
export default firebaseConfig;
